// removed by extract-text-webpack-plugin
module.exports = {"base":"MemberName_base--3nc2W","role":"MemberName_role--27RAh","name":"MemberName_name--Dfq7G"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/MemberName/MemberName.css
// module id = 1820
// module chunks = 16